/*global makeTimer*/
(function () {
    "use strict";

    const ANCHOR_ADSL = "ADSL";
    const ANCHOR_FIBER = "FIBRE";

    function focusOnSelectedTabByAnchorValue() {

        const urlParts = document.URL.split("#");
        const anchor = urlParts.length > 1
            ? urlParts[1]
            : "";

        let tabListToAdd = "";
        let tabListToRemove = "";
        let tabPanelToAdd = "";
        let tabPanelToRemove = "";

        if (anchor.search(ANCHOR_ADSL) === 0) {
            tabListToAdd = "pills-adsl-tab";
            tabListToRemove = "pills-fibre-tab";
            tabPanelToAdd = "pills-adsl";
            tabPanelToRemove = "pills-fibre";
        } else if (anchor.search(ANCHOR_FIBER) === 0) {
            tabListToAdd = "pills-fibre-tab";
            tabListToRemove = "pills-adsl-tab";
            tabPanelToAdd = "pills-fibre";
            tabPanelToRemove = "pills-adsl";
        }

        if (tabListToAdd !== "") {
            const ariaCurrentAttribute = "aria-current";
            const ariaSelectedAttribute = "aria-selected";
            const activeClass = "active";
            const showClass = "show";

            const tabListToRemoveElement = document.getElementById(tabListToRemove);
            const tabListToAddElement = document.getElementById(tabListToAdd);
            const tabPanelToRemoveElement = document.getElementById(tabPanelToRemove);
            const tabPanelToAddElement = document.getElementById(tabPanelToAdd);

            tabListToRemoveElement.removeAttribute(ariaCurrentAttribute);
            tabListToRemoveElement.removeAttribute(ariaSelectedAttribute);
            tabListToRemoveElement.classList.remove(activeClass);

            tabListToAddElement.setAttribute(ariaSelectedAttribute, "true");
            tabListToAddElement.setAttribute(ariaCurrentAttribute, "page");
            tabListToAddElement.classList.add(activeClass);

            tabPanelToRemoveElement.classList.remove(activeClass);
            tabPanelToRemoveElement.classList.remove(showClass);
            tabPanelToAddElement.classList.add(activeClass);
            tabPanelToAddElement.classList.add(showClass);
        }
    }

    function setAdslAnchorforCurrentUrl() {
        window.location.hash = ANCHOR_ADSL;
        document.getElementById("header-xdsl").classList.remove("d-none");
        document.getElementById("header-fiber").classList.add("d-none");
    }

    function setFiberAnchorforCurrentUrl() {
        window.location.hash = ANCHOR_FIBER;
        document.getElementById("header-fiber").classList.remove("d-none");
        document.getElementById("header-xdsl").classList.add("d-none");
    }

    function removeUselessAnchorArgument() {
        let anchor = window.location.hash;
        let position = anchor.search("\\?");
        if (position !== -1) {
            window.location.hash = anchor.substring(0, position);
        } else if (anchor === "#" + ANCHOR_ADSL) {
            setAdslAnchorforCurrentUrl()
        } else if (anchor === "#" + ANCHOR_FIBER) {
            setFiberAnchorforCurrentUrl()
        }
    }

    function addElementsForModalToggle() {

        document.querySelectorAll(".offer-edito-content").forEach(
            function (edito) {
                const oeventCategory = edito.dataset.oeventCategory;
                const oeventLabel = edito.dataset.oeventLabel;

                edito.querySelectorAll("a").forEach(
                    function (link) {
                        link.classList.add("ob1-link-arrow", "ob1-link-small");
                        link.classList.remove("ob1-link", "underline-link");
                        link.target = "_self";
                        link.dataset.bsToggle = "modal";
                        link.dataset.oeventCategory = oeventCategory;
                        link.dataset.oeventLabel = oeventLabel;
                        link.dataset.oeventAction = link.getAttribute("href").substr(1);
                    }
                );
            }
        );
    }

    function setEligibilityButtonsUrl() {
        setRedirectButtonUrl("header-fiber-elg-test-btn-large");
        setRedirectButtonUrl("header-fiber-elg-test-btn-small");
        setRedirectButtonUrl("header-xdsl-elg-test-btn-large");
        setRedirectButtonUrl("header-xdsl-elg-test-btn-small");
        setRedirectButtonUrl("footer-fiber-elg-test-btn");
        setRedirectButtonUrl("footer-xdsl-elg-test-btn");
        setRedirectButtonUrl("elg-test-btn-fibre");
        setRedirectButtonUrl("elg-test-btn-xdsl");
    }

    function setRedirectButtonUrl(elementId) {
        const button = document.getElementById(elementId);
        const buttonUrl = button?.getAttribute("data-url");

        button?.addEventListener("click", function() {
            window.location.href = buttonUrl;
        });
    }

    removeUselessAnchorArgument();
    focusOnSelectedTabByAnchorValue();
    addElementsForModalToggle();
    setEligibilityButtonsUrl();
    document.getElementById("pills-adsl-tab")
        ?.addEventListener("click", function () {
            setAdslAnchorforCurrentUrl();
            setRedirectButtonUrl("elg-test-btn-xdsl");
        });

    document.getElementById("pills-fibre-tab")
        ?.addEventListener("click", function () {
            setFiberAnchorforCurrentUrl();
            setRedirectButtonUrl("elg-test-btn-fibre");
        });
    document.querySelectorAll(".msh-timer-th").forEach(makeTimer);
}());
